import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by Sector0x"
      links={[
        {
          key: 'sector0x',
          title: 'Sector0x',
          href: 'https://sector0x.com',
          blankTarget: true,
        },
        {
          key: 'github',
          title: <GithubOutlined />,
          href: 'https://github.com/miehoukingdom/sector0x-dashboard',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
